import { Breadcrumb } from 'antd';
import { LayoutCMS } from 'components';
import React from 'react';
import LandingPageForm from './libraries';

export const PageLandingPageFormComponent = (props: any) => {
    // set header page
    const title = 'Landing Page'
    const layoutCMSProps = {
        breadcrumb: (
            <>
                <Breadcrumb.Item>
                    {title}
                </Breadcrumb.Item>
            </>
        ),
        documentTitle: title,
        history: props.history,
        pageTitle: title,
    };

    return (
        <LayoutCMS {...layoutCMSProps}>
            <LandingPageForm {...props} />
        </LayoutCMS>
    );
};
export default PageLandingPageFormComponent;



// WEBPACK FOOTER //
// ./src/pages/landing-page-form/component.tsx